<style>
.center {
  margin: 20px 0 0 20px;
}
</style>

<template>
  <div class="app-container">
    <span style="margin-left:20px">>><b>权限转移</b></span>
    <ut-form :label-width="200">
      <ut-form-item>
        <template slot="label">
          <span style="color:red">*</span> 转交人
        </template>
        <ut-select
          v-model="fromUser"
          filterable
          clearable
          :style="{ width: '500px' }"
          :filter-method="filter"
        >
          <ut-option
            v-for="item in selectedSearchUsers || selectedUser"
            :value="item.id"
            :key="item.id"
            :label="item.name"
          ></ut-option>
        </ut-select>
      </ut-form-item>

      <ut-form-item>
        <template slot="label">
          <span style="color:red">*</span> 接收人
        </template>
        <ut-select
          v-model="toUsers"
          multiple
          filterable
          clearable
          :style="{ width: '500px' }"
          :filter-method="filter1"
        >
          <ut-option
            v-for="item in selectedSearchUsers2 || selectedUser2"
            :value="item.id"
            :key="item.id"
            :label="item.name"
          ></ut-option>
        </ut-select>
      </ut-form-item>

      <ut-form-item>
        <template slot="label">
          <span style="color:red">*</span> 转交策略
        </template>
        <ut-radio-group v-model="retainFrom">
          <ut-radio-button value="true">保留</ut-radio-button>
          <ut-radio-button value="false">删除</ut-radio-button>
        </ut-radio-group>
        <ut-alert type="warn" :style="{ width: '500px' }">
          选择删除，转交成功后转交人权限会被清空，默认保留
        </ut-alert>
      </ut-form-item>

      <ut-form-item>
        <ut-button type="primary" @click="submit">确认</ut-button>
        <ut-button @click="goBack">取消</ut-button>
      </ut-form-item>
    </ut-form>
  </div>
</template>

<script lang="babel">
export default {
  data () {
    return {
      fromUser: '',
      toUsers: [],
      retainFrom: '',
      selectedSearchUsers: null,
      selectedUser: [],
      selectedSearchUsers2: null,
      selectedUser2: []
    }
  },
  methods: {
    submit () {
      var fromUser = this.fromUser
      var toUsers = this.toUsers
      var retainFrom = this.retainFrom

      if (!fromUser) {
        this.$message.error('转交人不能为空!')
        return false
      }
      if (!toUsers) {
        this.$message.error('接收人不能为空！')
        return false
      }
      if (!retainFrom) {
        this.$message.error('转交策略不能为空！')
        return false
      }
      var sendData = {}
      sendData.fromUser = this.fromUser
      sendData.toUsers = this.toUsers
      sendData.retainFrom = this.retainFrom

      this.$http({
        method: 'post',
        url: 'permission/transfer',
        data: JSON.stringify(sendData)
      })
        .then(response => {
        // 这里使用了ES6的语法
          console.log(response) // 请求成功返回的数据
          if (response.data.code == 0) {
            this.$message.success('添加成功')
            this.$router.push({ path: '/users' })
          } else {
            this.$message.error(response.data.message)
            return false
          }
        })
        .catch(error => {
          console.log(error) // 请求失败返回的数据
        })
    },
    goBack () {
      this.$router.push({ path: '/users' })
    },
    filter (val) {
      const data = []
      const inp = val && val.toLowerCase()
      this.selectedUser.map(item => {
        if (item.name.includes(inp) || item.id.toLowerCase().includes(inp)) {
          data.push(item)
        }
      })
      if (data.length) {
        this.selectedSearchUsers = data
      } else {
        this.selectedSearchUsers = null
      }
    },
    filter1 (val) {
      const data = []
      const inp = val && val.toLowerCase()
      this.selectedUser2.map(item => {
        if (item.name.includes(inp) || item.id.toLowerCase().includes(inp)) {
          data.push(item)
        }
      })
      if (data.length) {
        this.selectedSearchUsers2 = data
      } else {
        this.selectedSearchUsers2 = null
      }
    }
  },
  created () {
    const { allPermiList } = this.$store.getters
    // eslint-disable-next-line no-undef
    const sysKey = BUILD_ENV === 'ali' ? 'argus-ali-users' : 'argus-users'
    if (!allPermiList.includes(sysKey)) {
      this.$router.push('/401')
    }
    // 应用加载
    this.$http({
      method: 'post',
      url: 'users/list.htm',
      data: '{}'
    })
      .then(response => {
      // 这里使用了ES6的语法
        console.log(response) // 请求成功返回的数据
        this.selectedUser = response.data
        this.selectedUser2 = JSON.parse(JSON.stringify(response.data))
      })
      .catch(error => {
        console.log(error) // 请求失败返回的数据
      })
  }
}
</script>
